<div class="bp-modal mod-lg wrapper">
  <bp-modal-header
    [title]="'send_via' | translate: [selectedCryptocoin?.name, selectedNetwork?.name]"
    class="font-semibold">
    <a (click)="onBackButtonClick()" (keydown.enter)="onBackButtonClick()" [tabIndex]="0" left>
      {{ "back" | translate }}
    </a>
    <a (click)="onCancelButtonClick()" (keydown.enter)="onCancelButtonClick()" [tabIndex]="0" right>
      {{ "cancel" | translate }}
    </a>
  </bp-modal-header>
  <div class="bp-modal-body">
    <div class="bp-modal-body-section">
      <div class="bp-modal-description">
        <div class="description-title">
          {{ "send_choose_recipient" | translate }}
        </div>
        <div class="info-title">
          {{ "send_info_choose_recipient" | translate }}
        </div>

        @if (selectedNetwork?.withdrawal_disclaimer) {
          <app-send-scam-warning
          [description]="selectedNetwork?.withdrawal_disclaimer"></app-send-scam-warning>
        }
        @if (data$ | async; as data) {
          <div class="form-group">
            <div class="form-search" [class.no-icon]="!!query">
              <input
                class="form-field"
                id="form-search"
                aria-label="Search through contacts"
                placeholder="{{ 'wallet_contact_search_hint' | translate }}"
                [(ngModel)]="query" />
              <button
                class="form-search-clear-button"
                type="button"
                [class.mod-input-field]="!!query"
                (click)="clearQuery()">
                <span class="bpi__icon-close-round font-bold"></span>
              </button>
            </div>
          </div>
          @if (data.wallets) {
            <wallets-list
              [wallets]="data.wallets"
              [query]="query"
              [viewType]="addressBookWalletViewType.WITHDRAW"
              [sendWalletId]="accountWalletId"
              [selectedCryptocoin]="selectedCryptocoin"
            [selectedNetwork]="selectedNetwork"></wallets-list>
          }

          <button class="btn btn-primary btn-inverse mod-button-width mt-30" (click)="addNewWallet()">
            {{ "new_recipient" | translate }}
          </button>
        } @else {
          <loading-spinner class="spinner green loader-big no-padding"></loading-spinner>
        }
      </div>
    </div>
  </div>
</div>
